import { createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row animated fadeIn" }
const _hoisted_2 = { class: "col-xl-12 col-lg-12" }
const _hoisted_3 = { class: "card shadow mb-4" }
const _hoisted_4 = { class: "card-header py-3 d-flex flex-row align-items-center justify-content-between" }
const _hoisted_5 = /*#__PURE__*/_createVNode("h6", { class: "m-0 font-weight-bold" }, " Last Trades ", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("i", { class: "fas fa-chevron-down" }, null, -1)
const _hoisted_7 = {
  key: 0,
  class: "card-body"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_9 = { class: "container" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" No trades to show. ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Loading lastest trades. Please wait. ")
const _hoisted_12 = { class: "d-block text-nowrap" }
const _hoisted_13 = { style: {"width":"140px"} }
const _hoisted_14 = { class: "d-block text-nowrap" }
const _hoisted_15 = { class: "d-block text-nowrap" }
const _hoisted_16 = { class: "d-block text-nowrap" }
const _hoisted_17 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "btn btn-sm btn-info"
}, [
  /*#__PURE__*/_createTextVNode(" Detail "),
  /*#__PURE__*/_createVNode("i", { class: "fas fa-search" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")
  const _component_icons_currency = _resolveComponent("icons-currency")
  const _component_router_link = _resolveComponent("router-link")
  const _component_DataTable = _resolveComponent("DataTable")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode("a", {
            class: ["show-toggle", { show: _ctx.show }],
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.showToggle()), ["prevent"]))
          }, [
            _hoisted_6
          ], 2)
        ]),
        (_ctx.show)
          ? (_openBlock(), _createBlock("div", _hoisted_7, [
              _hoisted_8,
              _createVNode("div", _hoisted_9, [
                _createVNode("div", null, [
                  _createVNode(_component_DataTable, {
                    value: _ctx.lastTrades,
                    paginator: true,
                    rows: 10,
                    loading: _ctx.status == 'fetching',
                    paginatorTemplate: "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
                    rowsPerPageOptions: [10, 20, 50],
                    currentPageReportTemplate: "Showing {first} to {last} of {totalRecords}",
                    autoLayout: true
                  }, {
                    empty: _withCtx(() => [
                      _hoisted_10
                    ]),
                    loading: _withCtx(() => [
                      _hoisted_11
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_Column, {
                        field: "customerFullname",
                        header: "User",
                        bodyStyle: "text-align: left"
                      }, {
                        body: _withCtx((slotProps) => [
                          _createTextVNode(_toDisplayString(slotProps.data.customer.firstName +
                        ' ' +
                        slotProps.data.customer.lastName), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "amount",
                        header: "Amount",
                        headerStyle: "text-align: right",
                        bodyStyle: "text-align: right"
                      }, {
                        body: _withCtx((slotProps) => [
                          _createVNode("span", _hoisted_12, _toDisplayString(_ctx.format(slotProps.data.amount, 5)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "pair",
                        header: "Pair",
                        headerStyle: "text-align: center",
                        bodyStyle: "text-align: center"
                      }, {
                        body: _withCtx((slotProps) => [
                          _createVNode("span", _hoisted_13, [
                            _createTextVNode(_toDisplayString(slotProps.data.pairId) + " ", 1),
                            _createVNode(_component_icons_currency, {
                              cryptoCurrency: slotProps.data.pair.baseCurrencyId,
                              localCurrency: slotProps.data.pair.quoteCurrencyId,
                              width: '20',
                              height: '20',
                              color: true,
                              reverse: slotProps.data.side == 1 ? false : true 
                            }, null, 8, ["cryptoCurrency", "localCurrency", "reverse"])
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "side",
                        header: "Side"
                      }, {
                        body: _withCtx((slotProps) => [
                          _createTextVNode(_toDisplayString(slotProps.data.side == 1 ? 'BUY' : 'SELL'), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "amount",
                        header: "Total price",
                        headerStyle: "text-align: right",
                        bodyStyle: "text-align: right"
                      }, {
                        body: _withCtx((slotProps) => [
                          _createVNode("span", _hoisted_14, "$ " + _toDisplayString(_ctx.formatPrice(slotProps.data.finalPrice)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "amount",
                        header: "Total cost",
                        headerStyle: "text-align: right",
                        bodyStyle: "text-align: right"
                      }, {
                        body: _withCtx((slotProps) => [
                          _createVNode("span", _hoisted_15, "$ " + _toDisplayString(_ctx.formatPrice(slotProps.data.totalCost)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "amount",
                        header: "Base revenue",
                        headerStyle: "text-align: right",
                        bodyStyle: "text-align: right"
                      }, {
                        body: _withCtx((slotProps) => [
                          _createTextVNode(_toDisplayString(_ctx.format(slotProps.data.baseCurrencyRevenue)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "amount",
                        header: "Quote revenue",
                        headerStyle: "text-align: right",
                        bodyStyle: "text-align: right"
                      }, {
                        body: _withCtx((slotProps) => [
                          _createVNode("span", _hoisted_16, "$ " + _toDisplayString(_ctx.formatPrice(slotProps.data.quoteCurrencyRevenue)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "createdAt",
                        header: "Created At",
                        bodyStyle: "width:140px"
                      }, {
                        body: _withCtx((slotProps) => [
                          _createTextVNode(_toDisplayString(_ctx.formatDate(slotProps.data.createdAt)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "quantity",
                        header: "Action",
                        headerStyle: "text-align:center",
                        bodyStyle: "width:110px"
                      }, {
                        body: _withCtx((slotProps) => [
                          _createVNode(_component_router_link, {
                            to: {
                        name: 'dashboard.order-details',
                        params: { id: slotProps.data.id }
                      }
                          }, {
                            default: _withCtx(() => [
                              _hoisted_17
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value", "loading"])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}